import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import useAutoScroll from "../../../hooks/useAutoScroll";

const GetStarted = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const gridRef = useAutoScroll(10000);

  const roles = [
    {
      key: "guardian",
      label: t("hero.roles.petGuardian"),
      color: "purple",
      image: "/Landing page assets/road friend2_scene.jpg",
      link: "/auth/register/pet_guardian",
    },
    {
      key: "veterinarian",
      label: t("hero.roles.veterinarian"),
      color: "teal",
      image: "/Landing page assets/vet (1)_scene.png",
      link: "/auth/register/veterinarian",
    },
    {
      key: "firms",
      label: t("hero.roles.firms"),
      color: "slate",
      image: "/Landing page assets/firms_scene.png",
      link: "/auth/register/firm",
    },
    {
      key: "provider",
      label: t("hero.roles.serviceProvider"),
      color: "red",
      image: "/Landing page assets/shop_scene.png",
      link: "/auth/register/service_provider",
    },
  ];

  return (
    <section className="landing-get-started">
      <h2 className="landing-section-title">{t("hero.getStarted.title")}</h2>
      <p className="landing-section-subtitle">{t("hero.journey.subtitle")}</p>
      <div className="landing-roles-grid" ref={gridRef}>
        {roles.map((role) => (
          <div
            key={role.key}
            className={`landing-role-card ${role.color}`}
            onClick={() => role.link && navigate(role.link)}
            style={{ cursor: role.link ? "pointer" : "default" }}
          >
            <div className="landing-role-image">
              {role.image ? (
                <img src={role.image} alt={role.label} style={{ transform: role.key !== "provider" ? "scaleX(-1)" : "none" }} />
              ) : (
                <span>[ Image ]</span>
              )}
            </div>
            <div className={`landing-role-label ${role.color}`}>{role.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default GetStarted;
